
import { Body } from '@panwds/react-table'
import { Card, CardBody } from '@panwds/react-ui'
/**
 *   TODO: Brief what is this component/class do
 */
import { useCallback } from 'react'
import './splashScreen.scss'
import { CloudImg } from '../../../common/assets/images'
import Link from '../../../common/components/link/Link'
import { BUTTON_CONTACT_SUPPORT_LINK, CONTACT_SUPPORT_URL } from '../constants/SubscriptionConstant'
import SplashFooter from './SplashFooter'
import PaloAltoNetworks from './PaloAltoNetworks'


const SplashScreen = () => {

  const switchToPanorama = useCallback(() => {
    window.open(CONTACT_SUPPORT_URL, '_blank')
  }, [])


  return (<div className='splashScreen'>
    <div className='splashMain tw-h-full tw-block tw-flex tw-flex-col tw-justify-center tw-items-center'>
      <Card style={{ width: '448px', height: '504px' }}>
        <CardBody addClassName='tw-h-full'>
          <div className='tw-flex tw-flex-col tw-h-full'>
            <PaloAltoNetworks />
            <div className='tw-flex-grow tw-flex tw-flex-col tw-mt-6 tw-items-center'>
              <div className='tw-mt-4 tw-pb-4'>
                <img style={{ width: '117px', height: '117px' }}
                  className='tw-ml-4'
                  src={CloudImg} alt={'cloudimg'} />
              </div>
              <div className='tw-mt-4 tw-pb-4 tw-text-center'>
                <Body className='tw-ml-4' style={{ fontSize: '20px' }}>Something went wrong! Please contact support!</Body>
              </div>
            </div>
          </div>
        </CardBody>
      </Card>
      <div className='tw-mt-2'>
        <Link onClick={switchToPanorama}>{BUTTON_CONTACT_SUPPORT_LINK}</Link>
      </div>
    </div>
    <div className='splashFooter tw-flex tw-flex-row'>
      <SplashFooter showLogo={true} showSignature={true}/>
    </div>
  </div>)
}
SplashScreen.propTypes = {}
export default SplashScreen
